<p-card styleClass="very-compact-card p-3">
  <h3 class="mb-3">Заказ</h3>
  <small
    *ngIf="errors"
    class="p-error">
    {{ errors | joinWithChild }}
  </small>

  <div
    *ngIf="orders?.length"
    class="mt-2 max-h-29rem overflow-y-auto overflow-x-hidden">
    <crm-table
      [columns]="columns"
      [values]="orders"
      name="deal-orders-form"
      styleClass="p-datatable-sm">
      <ng-template
        #rowTemplate
        let-order="item"
        let-index="rowIndex">
        <ng-container *ngIf="toOrder(order) as order">
          <tr>
            <td>
              {{ order.nomenclatureItem?.name }}
            </td>
            <td>
              <p-inputNumber
                [(ngModel)]="order.count"
                inputStyleClass="w-full"
                [min]="0"
                (ngModelChange)="changeCount(order, $event)"
                [class]=" errors?.[index]?.count ? 'deal-order-input-count ng-invalid ng-dirty' : 'deal-order-input-count'"
                [styleClass]="errors?.[index]?.count ? 'ng-invalid ng-dirty' : ''"></p-inputNumber>
              <small
                *ngIf="errors?.[index]?.count"
                class="p-error">
                {{ errors[index].count | join }}
              </small>
            </td>
            <td>
              <p-inputNumber
                [(ngModel)]="order.price"
                [min]="0"
                (ngModelChange)="changePrice(order, $event)"
                [class]="errors?.[index]?.price ? 'deal-order-input-price ng-invalid ng-dirty' : 'deal-order-input-price'"
                [styleClass]="errors?.[index]?.price ? 'ng-invalid ng-dirty' : ''"></p-inputNumber>
              <small
                *ngIf="errors?.[index]?.price"
                class="p-error">
                {{ errors[index].price | join }}
              </small>
            </td>
            <td>
              <p-inputNumber
                [(ngModel)]="order.amount"
                [disabled]="true"
                [class]="errors?.[index]?.amount ? 'deal-order-input-price ng-invalid ng-dirty' : 'deal-order-input-price'"
                [styleClass]="errors?.[index]?.amount ? 'ng-invalid ng-dirty' : ''"></p-inputNumber>
              <small
                *ngIf="errors?.[index]?.amount"
                class="p-error">
                {{ errors[index].amount | join }}
              </small>
            </td>
            <td>
              <button
                pButton
                type="button"
                icon="pi pi-times"
                class="p-button-rounded p-button-danger p-button-text"
                (click)="deleteOrder(order)"></button>
            </td>
          </tr>
        </ng-container>
      </ng-template>
      <ng-template #footerTemplate>
        <tr>
          <td class="text-lg uppercase">Итого:</td>
          <td colspan="2"></td>
          <td>
            <p class="text-lg text-black p-2">{{ orders || [] | sum: 'amount' | number: '.0-0' }}</p>
          </td>
          <td></td>
        </tr>
      </ng-template>
    </crm-table>
  </div>

  <div
    *ngIf="!isShowNomenclatures"
    class="mt-3">
    <button
      pButton
      label="Добавить"
      icon="pi pi-plus"
      class="p-button-outlined p-button-success"
      (click)="toggleAddNomenclature()"></button>
  </div>

  <div
    *ngIf="isShowNomenclatures"
    class="flex align-items-center gap-3 w-full mt-3">
    <crm-nomenclature-item-auto-complete
      [(selectedNomenclature)]="selectedNomenclature"
      [excludeIds]="excludeIds"
      [customSearch]="false"
      [showClear]="true"
      class="w-full"
      styleClass="w-full"
      [inputStyle]="{ width: '100%' }"
      placeholder="Выберите номенклатуру"
      (selectedNomenclatureChange)="addOrders()"></crm-nomenclature-item-auto-complete>

    <i
      class="pi pi-times text-red-500 hover:text-red-300 cursor-pointer"
      style="font-size: 1.3rem"
      (click)="isShowNomenclatures = false"></i>
  </div>
</p-card>
